export default __webpack_public_path__ + "static/media/step1.e9222c51.jpg";